import React from 'react';

export const SignSmallIcon = (props: any) => {
  return (
    <svg
      width="124"
      height="61"
      viewBox="0 0 124 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 6.65039H67.3496V54.3496H7C3.49299 54.3496 0.650391 51.507 0.650391 48V13C0.650391 9.49299 3.49299 6.65039 7 6.65039Z"
        stroke="#0047A3"
        stroke-opacity="0.7"
        stroke-width="1.3"
      />
      <path d="M124 61H55V46H29V0H124V61Z" fill="white" />
      <path
        d="M34.184 8.084C33.7267 8.084 33.33 7.965 32.994 7.727C32.658 7.489 32.42 7.16 32.28 6.74L33.141 6.418C33.2483 6.65133 33.3953 6.838 33.582 6.978C33.7687 7.118 33.9787 7.188 34.212 7.188C34.4547 7.188 34.646 7.13667 34.786 7.034C34.9307 6.93133 35.003 6.78433 35.003 6.593C35.003 6.495 34.9797 6.40867 34.933 6.334C34.8863 6.25933 34.807 6.19167 34.695 6.131C34.583 6.07033 34.4827 6.02367 34.394 5.991C34.31 5.95367 34.1817 5.907 34.009 5.851C33.813 5.78567 33.6637 5.73433 33.561 5.697C33.463 5.65967 33.3323 5.59667 33.169 5.508C33.0057 5.41933 32.882 5.33067 32.798 5.242C32.714 5.14867 32.637 5.02733 32.567 4.878C32.5017 4.724 32.469 4.55367 32.469 4.367C32.469 3.98433 32.6183 3.66467 32.917 3.408C33.2157 3.14667 33.6193 3.016 34.128 3.016C34.548 3.016 34.9003 3.121 35.185 3.331C35.4743 3.541 35.6657 3.814 35.759 4.15L34.912 4.43C34.758 4.08467 34.478 3.912 34.072 3.912C33.8667 3.912 33.7057 3.954 33.589 4.038C33.477 4.11733 33.421 4.23167 33.421 4.381C33.421 4.479 33.4677 4.56767 33.561 4.647C33.6543 4.72167 33.75 4.78 33.848 4.822C33.946 4.85933 34.1 4.913 34.31 4.983C34.4733 5.039 34.5993 5.08333 34.688 5.116C34.7767 5.14867 34.898 5.2 35.052 5.27C35.206 5.34 35.325 5.41233 35.409 5.487C35.4977 5.56167 35.5887 5.65267 35.682 5.76C35.78 5.86267 35.85 5.98633 35.892 6.131C35.934 6.271 35.955 6.425 35.955 6.593C35.955 7.055 35.787 7.419 35.451 7.685C35.1197 7.951 34.6973 8.084 34.184 8.084Z"
        fill="#1B1D1F"
      />
    </svg>
  );
};
